export default __webpack_public_path__ + "static/media/user-default.7b2af472.png";